module.exports = __webpack_public_path__ + "static/media/works.f4258fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/works.jpg
// module id = 487
// module chunks = 0